"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("./SiteConfig.cjs");function t({plugins:e=[]}={}){window.__CODE_STUDIO__||(window.__CODE_STUDIO__=i.default);for(const o of e)o.onCoreReady(i.default)}exports.initializeCore=t;
//# sourceMappingURL=initializeCore.cjs.map
